export const EMBED_DEMO = 'demo';
export const DEMO_PRODUCTION = 'demo-production';
